export function SuccessAlertPlan(message) {
  const alertBox = document.createElement("div");

  alertBox.innerHTML = `
      <div style="display: flex; align-items: center; gap: 12px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect width="40" height="40" rx="5" fill="#E3F3FF"/>
          <path d="M28 14L17 25L12 20" stroke="#165D31" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span style="font-size: 0.875rem;" class="ftw-4 common-text">${message}</span>
      </div>
    `;

  /* ---------- CONTAINER STYLE ---------- */
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.top = "100px";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#FFF";
  alertBox.style.borderRadius = "13px";
  alertBox.style.padding = "12px 16px";
  alertBox.style.boxSizing = "border-box";

  /* 🔥 IMPORTANT FIX */
  alertBox.style.zIndex = "10002"; // higher than blur & popup
  alertBox.style.pointerEvents = "none";

  alertBox.style.animation = "slideDown 0.3s ease-out forwards";
  alertBox.style.boxShadow = "0 13px 27px 0 rgba(0, 0, 0, 0.10)";

  /* ---------- ANIMATIONS ---------- */
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
  
      @keyframes fadeOut {
        from {
          opacity: 1;
          transform: translate(-50%, 0);
        }
        to {
          opacity: 0;
          transform: translate(-50%, -20px);
        }
      }
    `;
  document.head.appendChild(styleSheet);

  document.body.appendChild(alertBox);

  alertBox.classList.add("alert-box");

  /* ---------- AUTO REMOVE ---------- */
  setTimeout(() => {
    alertBox.style.animation = "fadeOut 0.3s ease-out forwards";
    setTimeout(() => {
      if (alertBox.parentNode) {
        document.body.removeChild(alertBox);
      }
      document.head.removeChild(styleSheet);
    }, 300);
  }, 3000);
}
